export enum AddressTypeEnum {
    TAX_ADDRESS = 'Common.AddressType.Tax',
    DOCUMENT_ADDRESS = 'Common.AddressType.Document',
    BILLING_ADDRESS = 'Common.AddressType.Billing',
    COMPANY_ADDRESS = 'Common.AddressType.Company',
}